import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '../../../shared/ui/pagination/pagination.config';
import { PagedResult } from '../models/pagination.model';
import { UserImportQuery, UserImportRecord } from '../models/user-import.model';

@Injectable({
  providedIn: 'root',
})
export class UserImportsApiService {
  private readonly http = inject(HttpClient);
  private readonly api = environment.apiUrl.replace(/\/$/, '');

  getUserImports(
    page = DEFAULT_PAGE,
    pageSize = DEFAULT_PAGE_SIZE,
    query: UserImportQuery = {},
  ): Observable<PagedResult<UserImportRecord>> {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    params = this.addParams(params, query);
    return this.http.get<PagedResult<UserImportRecord>>(`${this.api}/user-import-records`, { params });
  }

  getUserImport(publicId: string): Observable<UserImportRecord> {
    return this.http.get<UserImportRecord>(`${this.api}/user-import-records/${publicId}`);
  }

  private addParams(params: HttpParams, values: object): HttpParams {
    let result = params;
    Object.entries(values).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        result = result.set(key, String(value));
      }
    });
    return result;
  }
}
